import React, { useState, useEffect } from "react";

import Paper from "@material-ui/core/Paper";
import { TextField } from "@material-ui/core";

import { StyledGrid, Button } from "components/simple";
import { StyledHr, StyledSubTitle } from "./styled";
import { spacingDefaults } from "style/constants";

interface NotesProps {
  title: string;
  placeholder?: string;
  value: string | null;
  onSave: (s: string) => Promise<boolean>;
}

const Notes: React.FC<NotesProps> = ({ title, value, placeholder, onSave }: NotesProps) => {
  const [edit, setEdit] = useState(false);
  const [notes, setNotes] = useState(value || "");

  useEffect(() => {
    setNotes(value || "");
  }, [title, value]);

  const handleNotesChange = (e: React.ChangeEvent<unknown>): void => {
    const value = (e.target as HTMLInputElement).value;
    setNotes(value);
  };

  const handleCancelNotes = (): void => {
    setNotes(value || "");
    setEdit(false);
  };

  const saveNotes = async (): Promise<void> => {
    const response = await onSave(notes);
    if (!response) setNotes(value || "");
    setEdit(false);
  };

  return (
    <Paper>
      <StyledGrid container direction={"column"} justifyContent="space-between">
        <StyledGrid item>
          <StyledSubTitle>{title}</StyledSubTitle>
          <StyledHr />
          <StyledGrid padding={spacingDefaults.normal}>
            {edit ? (
              <TextField
                autoFocus
                fullWidth
                multiline
                placeholder={placeholder || "Notes"}
                variant="outlined"
                rows={4}
                value={notes}
                onChange={handleNotesChange}
              />
            ) : (
              notes
            )}
          </StyledGrid>
        </StyledGrid>

        <StyledGrid
          container
          justifyContent={"flex-end"}
          padding={spacingDefaults.normal}
          width="100%"
        >
          {edit ? (
            <>
              <StyledGrid marginRight={spacingDefaults.normal}>
                <Button compressed inverted secondary onClick={handleCancelNotes}>
                  Cancel
                </Button>
              </StyledGrid>
              <StyledGrid>
                <Button compressed onClick={saveNotes}>
                  Save
                </Button>
              </StyledGrid>
            </>
          ) : (
            <Button compressed onClick={() => setEdit(true)}>
              {!value ? "Add" : "Edit"}
            </Button>
          )}
        </StyledGrid>
      </StyledGrid>
    </Paper>
  );
};

export default Notes;
